module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_yoboshika-4401433da35a570a533d3bcb9d3868c9.png";